import React from 'react';
import PropTypes from 'prop-types';
import clickOnActivateKey from '../../../utils/keyboard';

import './custom_checkbox.css';

function CustomCheckbox(props) {
  return (
    <div
      className="custom-checkbox"
      role="checkbox"
      aria-checked={props.checked}
      tabIndex={0}
      data-track={props.name || 'custom-checkbox'}
      onClick={props.onClick}
      onKeyDown={clickOnActivateKey}
      style={props.custom_style}
    >
      <input
        type="checkbox"
        readOnly
        tabIndex={-1}
        aria-hidden="true"
        checked={props.checked}
        style={props.input_style}
        name={props.name || ''}
      />
      {props.show_label ? (
        <div className="custom-checkbox-label" style={props.label_style}>
          {props.label}
        </div>
      ) : null}
    </div>
  );
}

CustomCheckbox.propTypes = {
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  show_label: PropTypes.bool,
  custom_style: PropTypes.object,
  label_style: PropTypes.object,
  input_style: PropTypes.object
};

CustomCheckbox.defaultProps = {
  label: 'label',
  checked: false,
  onClick: () => console.log('check clicked'),
  show_label: true,
  custom_style: {},
  label_style: {},
  input_style: {}
};

export default CustomCheckbox;
